import React from 'react';

function WarningIcon(props) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      role="img"
    >
      <title>Warning Icon</title>
      <g id="Group_9120" transform="translate(-580.483 -580.5)">
        <g id="Group_9119" transform="translate(581 581)">
          <g id="Path_13954">
            <path
              fill={props.color || 'white'}
              d="M102.96,933.83C40.49,929.15-4.89,876.34-0.35,816.02c1.36-18.16,7.3-35.76,17.13-51.03l392.66-649.21
     c26.15-46.9,86.82-64.12,134.61-37.46c15.76,8.75,28.86,21.72,37.88,37.52l399.68,648.71c32.81,49.8,18.83,118.04-31.7,151.35
     c-15.37,10.19-33.31,16.32-51.81,17.83L102.96,933.83z M495.73,122.77c-14.85,0-29.24,7.83-36.99,21.67L64.88,795.63
     c-4.79,7.35-7.69,15.93-8.36,24.68c-2.17,28.97,19.61,54.37,48.6,56.54l790.7-0.06c6.63-0.61,15.26-3.62,22.67-8.47
     c24.29-16.04,31.03-48.8,15.04-73.08l-400.66-650.3c-4.32-7.55-9.89-13.06-16.57-16.79C509.77,124.5,502.7,122.77,495.73,122.77z
     "
            />
          </g>
          <g id="Group_9118" transform="translate(7.521 3.182)">
            <g id="Path_13955">
              <path
                fill={props.color || 'white'}
                d="M450.06,751.85c-1.42-24.88,17.6-46.2,42.47-47.62c1.05-0.06,2.11-0.08,3.16-0.07c26.34,1.29,46.64,23.68,45.35,50.02
       c-1.2,24.53-20.82,44.15-45.35,45.35c-24.89,0.36-45.35-19.53-45.71-44.41C449.98,754.04,450,752.94,450.06,751.85z
        M469.29,641.88L458.5,272.59h73.81l-10.72,369.29H469.29z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default WarningIcon;
